// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1W_es","productName":"Table_productName__3g2A-"};